export default __webpack_public_path__ + "static/media/loading2.9b83f7d8.gif";